import {Ages, dateToFormat, tsToServerDate} from "./ages";

/**
 * Profile-freeze date math, shared by every surface that renders a frozen
 * profile (home accordion, slots calendar, booking modal).
 *
 * `frozenUntil` is the API-emitted, inclusive YYYY-MM-DD end date of a freeze
 * that is active today, or null/undefined when the profile is not frozen.
 */

/** Whether the calendar date of `ts` falls inside the active freeze window. */
export const isTsWithinFreeze = (frozenUntil: string | null | undefined, ts: number): boolean =>
    !!frozenUntil && ts >= 0 && tsToServerDate(ts) <= new Date(`${frozenUntil}T00:00:00`);

/**
 * Whether the freeze covers every date the slots calendar can show (through
 * the end of the last selectable week). When true, Manage/View has nothing
 * attendable or bookable to offer and the entry point should say so instead.
 */
export const freezeCoversBookingWindow = (
    frozenUntil: string | null | undefined,
    weeksAvailableFuture: number,
): boolean =>
    isTsWithinFreeze(
        frozenUntil,
        new Ages().startOfWeek().startOfDay().addWeeks(weeksAvailableFuture).endOfWeek().toTs(),
    );

/** Human-readable freeze end date for labels ("15 Aug 2026"). */
export const formatFreezeDate = (frozenUntil: string): string =>
    dateToFormat(new Date(`${frozenUntil}T00:00:00`), "dd mmm yyyy");
